// src/pages/AdminLogin.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await fetch(`${process.env.REACT_APP_EXPRESS_URL}/api/admin-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
      credentials: 'include', // ← REQUIRED to accept cookies
    });

    const result = await res.json();
    setLoading(false);

    if (!res.ok || result.error) {
      setIsError(true);
      setMessage(result.error || 'Login failed.');
    } else {
      setIsError(false);
      setMessage('✅ Logged in successfully!');
      navigate('/admin/dashboard');
    }
  };

  const navigate = useNavigate();

  return (
    <div className="bg-pink-50 dark:bg-gray-900 px-4 flex justify-center pt-24">
      <div className="bg-white dark:bg-gray-800 shadow-2xl rounded-2xl w-full max-w-sm p-6">
        <h2 className="text-2xl font-bold text-pink-700 dark:text-pink-300 mb-6 text-center">
          Admin Login
        </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Email
            </label>
            <input
              type="email"
              required
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-black dark:text-white focus:outline-none focus:ring-2 focus:ring-pink-400"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Password
            </label>
            <input
              type="password"
              required
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-black dark:text-white focus:outline-none focus:ring-2 focus:ring-pink-400"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="w-full bg-pink-600 hover:bg-pink-700 text-white py-2 rounded-lg font-semibold transition flex items-center justify-center text-lg"
            disabled={loading}
          >
            {loading ? <span className="animate-spin inline-block">🍩</span> : 'Log In'}
          </button>
          {message && (
            <div
              className={`px-4 py-2 rounded text-sm ${
                isError
                  ? 'bg-red-100 border border-red-400 text-red-700 dark:bg-red-800 dark:text-red-100'
                  : 'bg-green-100 border border-green-400 text-green-700 dark:bg-green-800 dark:text-green-100'
              }`}
            >
              {message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
